import { Deserializable } from '../interfaces';

export class Services implements Deserializable {
  descripcion: string;
  idServicio: number;
  idTarjeta: number;
  idTipoServicio: number;
  nombreServicio: string;
  urlIcono: string;
  urlImagen: string;
  urlServicio: string;
  posicion: number;

  constructor() {
    this.descripcion = '';
    this.idServicio = 0;
    this.idTarjeta = 0;
    this.idTipoServicio = 0;
    this.posicion = 0;
    this.nombreServicio = '';
    this.urlIcono = '';
    this.urlImagen = '';
    this.urlServicio = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
